<script setup lang="ts">
import DeleteButton from "@/components/DeleteButton.vue";
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import EditLink from "@/components/links/EditLink.vue";
import EnterLink from "@/components/links/EnterLink.vue";
import ManagementLayout from "@/layouts/ManagementLayout.vue";
import { Plus, Trash } from "@iconoir/vue";
import { RouterLink } from "vue-router";
import { useDeleteCanvass, useGetAllCanvasses } from "./canvassesCrud";

const { canvasses, getCanvassesStatus } = useGetAllCanvasses();
const { deleteCanvass, resetDeleteCanvass, deleteCanvassStatus } =
  useDeleteCanvass();
</script>

<template>
  <ManagementLayout>
    <template #header>
      <h1>Haustüraktionen</h1>
      <RouterLink :to="{ name: 'newCanvass' }" class="button" role="button">
        <Plus /> Haustüraktion anlegen
      </RouterLink>
    </template>

    <HandleQueryStatus :query-status="getCanvassesStatus">
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Gebiet</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="canvass in canvasses" :key="canvass.id">
            <td>
              <RouterLink
                :to="{
                  name: 'editCanvass',
                  params: { id: canvass.id },
                }"
                class="column--primary-action"
              >
                {{ canvass.name }}
              </RouterLink>
            </td>
            <td>{{ canvass.area.name }}</td>
            <td class="actions">
              <EnterLink
                :to="{
                  name: 'canvassFlowOverview',
                  params: { canvassId: canvass.id },
                }"
              />
              <EditLink
                :to="{ name: 'editCanvass', params: { id: canvass.id } }"
              />
              <DeleteButton
                class="button button--tertiary"
                :deleting-status="deleteCanvassStatus"
                @initiated="resetDeleteCanvass()"
                @confirmed="deleteCanvass(canvass.id)"
              >
                <Trash /> <span class="visually-hidden"> Löschen </span>
                <template #confirmation>
                  Möchtest du die Haustüraktion "{{ canvass.name }}" wirklich
                  löschen?
                  <strong>
                    Alle erfassten Häuser und Gespräche dieser Haustüraktion
                    gehen dabei unwiderruflich verloren.
                  </strong>
                  Die Kontakte selbst bleiben erhalten.
                </template>
              </DeleteButton>
            </td>
          </tr>
        </tbody>
      </table>
    </HandleQueryStatus>
  </ManagementLayout>
</template>
